import { Injectable,EventEmitter } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CountriesService {

    constructor(private _http: HttpClient) { }

    getcountries(data) {
        return this._http.post(environment.api_url+'master/country/list',data);
    }

    savecountry(data) {
        return this._http.post(environment.api_url+'master/country/add',data);
    }

    updatecountry(data) {
        return this._http.post(environment.api_url+'master/country/update',data);
    }

}
